import React from 'react';
import {Link, Text} from "@nextui-org/react";

function AppFooter() {
    return (
        <footer>
            <Text>
                Copyright &copy; 2020-{new Date().getFullYear()} &nbsp;
                <Link href={'https://github.com/chirag-ji'} target={'_blank'}>Chirag Gupta</Link>
            </Text>
        </footer>
    );
}

export default AppFooter;
